module.exports = __webpack_public_path__ + "static/media/icon-3.16c5502f.svg";